import React from "react";
import "./imgStyle.css";

function ImgDialog(props) {
  const {
    visible,
    actionsPannel,
    children,
    color = "bg-red",
    handleCloseDialog = () => {},
    size = "w-1/3",
    title,
  } = props;

  const handleCloseDialogContainer = (event) => {
    if (event.target.id === "container") handleCloseDialog();
  };
  if (!visible) return null;

  return (
    <div
      id="container"
      onClick={handleCloseDialogContainer}
      style={{ zIndex: 1000 }}
      className="fixed inset-0  overflow-scroll  bg-black bg-opacity-60  flex items-center justify-center scrollbar-hide"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div> */}
        <div
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </div>
        <div
          className={`inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle ${size}`}
          role="dialog"
        >
          <div className="bg-white">
            <div className="bg-white rounded  flex flex-col overflow-y-auto h-auto">
              {children}
            </div>
          </div>
          {actionsPannel}
        </div>
      </div>
    </div>
  );
}

export default ImgDialog;
